// CONF
import { CreateConf } from './conf/Create.conf';
import { UpdateConf } from './conf/Update.conf';
// REDUX
import { reducer, actions, editSelector } from './slice';

// SELECTOR
import { tag } from './slice';

// SAGA
import { saga } from './saga';

// API
import { API } from './api';
import { DetailConf } from './conf/Detail.conf';

export { reducer, saga, tag };

const shippingDocuments = {
  tag,
  query: {
    detail: {
      action: actions.fetchDetailAction,
      settings: API.shippingDocument,
      populate: '*',
    },
    create: {
      settings: API.create,
    },
    delete: {
      settings: API.delete,
    },
    edit: {
      settings: API.update,
    },
  },
  edit: {
    conf: UpdateConf,
    selector: {
      data: editSelector,
    },
  },
  create: {
    conf: CreateConf,
  },
  detail: {
    conf: DetailConf,
    edit: {
      to: 'edit',
    },
  },
  remove: {
    navigate: '/department/shipping',
  },
};

export default shippingDocuments;
